module.exports = __webpack_public_path__ + "static/media/MCT-Web-Slider_2_1020px.e241e8bf.jpg";